import { getInitialDataWbff, getLatestAssetsWbff } from '@/services/wbff/top'
import { handleWbffResponse } from '@/utils/api/utils'

export const getInitialData = async (): Promise<any> => {
  const wbffResponse = await getInitialDataWbff()

  return handleWbffResponse(wbffResponse)
}

export const getLatestAssets = async (): Promise<any> => {
  const wbffResponse = await getLatestAssetsWbff()

  return handleWbffResponse(wbffResponse)
}
